import React from 'react';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import ProfileInfoPres from '../presentational/ProfileInfoPres';
import profileActions from '../state/profileActions';
import { updateProfileDetail } from 'src/services/profile.service';
import { transformFormValues } from 'src/helpers';
import WarningIcon from '@material-ui/icons/Warning';
import _ from 'lodash';
import { PHONE_ATTRIBUTE, PHONE_REGEX } from '../../../../constants/constants';
import moment from 'moment';
import intl from 'react-intl-universal';
import { formDataDifference } from 'src/helpers/formDataDifference.js';

class ProfileInfoContainer extends React.Component {
  state = {
    isEditable: false,
    showCancelEditlModal: false,
    showDeleteModal: false,
    validationError: false,
    isPhoneValid: false,
    initialFormData: {},
  };

  render() {
    return (
      <ProfileInfoPres
        profileId={this.props.profileId}
        isLoading={this.props.isLoading}
        onFormChange={this.handleFormChange}
        showCancelEditlModal={this.state.showCancelEditlModal}
        dynamicContent={this.props.dynamicContent}
        onEdit={this.handleEdit}
        onCancel={this.toggleEditModal.bind(null, true)}
        onCancelModal={this.handleCancel}
        onConfirmModal={this.toggleModal.bind(null, false)}
        onValidate={this.onValidate}
        onSave={this.handleSave}
        isEditable={this.state.isEditable}
        validationError={this.state.validationError}
        isPhoneValid={this.state.isPhoneValid}
      />
    );
  }

  handleFormChange = data => {
    this.formData = data;
  };

  handleSave = async () => {
    const { formValues } = this.formData;
    const { profileId } = this.props;

    formValues.dataRequests =
      Object.keys(this.state.initialFormData).length > 0
        ? formDataDifference(formValues.dataRequests, this.state.initialFormData.formValues.dataRequests)
        : formValues.dataRequests;

    const data = {
      entityId: profileId,
      ...transformFormValues(formValues),
    };

    this.props.toggleLoading(true);

    const result = await updateProfileDetail(data);

    if (result && result.error) {
      this.props.enqueueSnackbar(result.error.message, { variant: 'error' });
      this.props.toggleLoading(false);
    } else {
      // reload the data
      if (this.props.location && this.props.location.state === undefined) {
        await this.props.getDetails();
        this.props.getProfileName();
      } else {
        await this.props.getDetails(profileId);
        this.props.getProfileName(profileId);
      }
      this.setState({ isEditable: false });
      // this.props.enqueueSnackbar(intl.get('documents.documentDetails.messages.successMessage'), { variant: 'success' });
    }
  };

  handleEdit = () => {
    this.setState({ isEditable: true, initialFormData: this.formData });
  };

  toggleModal = status => {
    this.setState({
      showCancelEditlModal: status,
      showDeleteModal: status,
    });
  };

  toggleEditModal = status => {
    this.setState({
      showCancelEditlModal: status,
    });
  };

  handleCancel = () => {
    this.setState({
      showCancelEditlModal: false,
      showDeleteModal: false,
      isEditable: false,
    });
  };

  onValidate = (fields, setErrorFn) => {
    const { ey_heightcentimeters, telephone1, ey_birthdate } = fields;
    const pageElement = _.get(this.props, 'dynamicContent.pageElements');
    let validationError = false;
    let isPhoneMandatory = false;
    let phoneObj = _.find(pageElement, e => e.attributeName !== null && e.attributeName.toLowerCase() === PHONE_ATTRIBUTE.ATTRIBUTE_NAME);
    isPhoneMandatory = phoneObj && phoneObj.mandatory;
    if (ey_heightcentimeters) {
      if (ey_heightcentimeters < 50 || ey_heightcentimeters > 270) {
        const errorMsgHeightCent = (
          <span className="error-msg">
            <WarningIcon />
            <b>Height in Centimeters must be between 50 and 270.</b>
          </span>
        );

        setErrorFn('ey_heightcentimeters', true, errorMsgHeightCent);
        validationError = true;
      } else {
        setErrorFn('ey_assignmentenddate', false, null);
      }
    }

    if (isPhoneMandatory) {
      if (telephone1) {
        this.phoneValidation(telephone1, setErrorFn);
      }
    } else {
      if (telephone1) {
        this.phoneValidation(telephone1, setErrorFn);
      } else {
        setErrorFn('telephone1', false, null);
        this.setState({ isPhoneValid: true });
      }
    }

    if (ey_birthdate) {
      if (
        ey_birthdate !== '' &&
        moment()
          .startOf('day')
          .diff(moment(ey_birthdate), 'days') < 0
      ) {
        const errorMsgBirthdate = (
          <span className="error-msg">
            <WarningIcon />
            <b>{intl.get(`employees.refreshMessage.birthdateMessage`)}</b>
          </span>
        );

        setErrorFn('ey_birthdate', true, errorMsgBirthdate);
        validationError = true;
      } else {
        setErrorFn('ey_birthdate', false, null);
      }
    }

    this.setState({
      validationError,
    });
  };

  phoneValidation = (telephone1, setErrorFn) => {
    if (!telephone1.match(PHONE_REGEX.REGEX)) {
      const errorMsgPhone = (
        <span className="error-msg">
          <WarningIcon />
          <b>Invalid Phone Number</b>
        </span>
      );
      setErrorFn('telephone1', true, errorMsgPhone);
      this.setState({ isPhoneValid: false });
    } else {
      setErrorFn('telephone1', false, null);
      this.setState({ isPhoneValid: true });
    }
  };
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  getDetails: profileActions.getProfileDetail,
  toggleLoading: profileActions.toggleProfileDetailLoading,
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(ProfileInfoContainer));
